/**
 * I GET TO Self-Guided Course Ladder — central config
 *
 * The 8:8 → 11:11 numerology ladder:
 *   • Course 1 (Start Living)      → $8.88  (infinity / prosperity)
 *   • Course 2 (The Deeper Return) → $8.88  (same energy, deeper journey)
 *   • Bundle (Both Courses)        → $11.11 (master alignment — save $6.65)
 *
 * Edit the stripeLink fields below in ONE place — every CTA across the site
 * (homepage, /book, /shop, /draw, /sample-success, course landings) updates
 * automatically. While a link still starts with "PLACEHOLDER", that CTA
 * automatically falls back to waitlist-capture mode.
 */

// ─────────────────────────────────────────────────────────────────────────
// COURSE 1 — Start Living I GET TO (the doable on-ramp)
// ─────────────────────────────────────────────────────────────────────────
export const COURSE_1 = {
  id: "course-1",
  slug: "i-get-to-course",
  name: "Start Living I GET TO — Self-Guided to ACT NOW",
  shortName: "Start Living I GET TO",
  ladderLabel: "Start",
  tagline: "Your 20-page doable on-ramp into the Mind Body Spirit HYGIENE™ Method.",
  numerology: "$8.88 — infinity and prosperity.",
  price: 8.88,
  priceDisplay: "$8.88",
  pages: 20,
  // 🔧 Paste live Stripe Payment Link when ready
  stripeLink: "https://buy.stripe.com/PLACEHOLDER_COURSE_1",
  pdfDownload: "/downloads/I-GET-TO-Self-Guided-Course.pdf",
  pdfFileName: "Start-Living-I-GET-TO-Self-Guided-Course.pdf",
  landingUrl: "/i-get-to-course",
  successUrl: "/i-get-to-success",
  previewImages: [
    "/course-preview/page-1.jpg",
    "/course-preview/page-2.jpg",
    "/course-preview/page-3.jpg",
  ],
  coverImage: "/course-preview/page-1.jpg",
  phases: [
    { code: "S", title: "START HERE", note: "Read it. Do it. Anchor it." },
    { code: "A", title: "PHASE 1 — AWARENESS", note: "You're not broken. Notice what's running you." },
    { code: "C", title: "PHASE 2 — CLARITY", note: "Find your WHY. Name your values. Build your Code." },
    { code: "T", title: "PHASE 3 — TAPPED IN", note: "Daily Spiritual Hygiene. Boundaries. Receiving." },
    { code: "K", title: "KEEP GOING", note: "Your daily I GET TO ritual." },
  ],
  buyerGroup: "i-get-to-course-buyer",
  waitlistGroup: "i-get-to-course-waitlist",
};

// ─────────────────────────────────────────────────────────────────────────
// COURSE 2 — The Deeper Return (sustain, deepen, embody)
// ─────────────────────────────────────────────────────────────────────────
export const COURSE_2 = {
  id: "course-2",
  slug: "i-get-to-deeper-return",
  name: "The Deeper Return — Keep Living I GET TO",
  shortName: "The Deeper Return",
  ladderLabel: "Deepen",
  tagline:
    "An 18-page integration intensive for the woman who's already done the brave thing — sustain it, deepen it, embody it.",
  numerology: "$8.88 — infinity and prosperity, deepened.",
  price: 8.88,
  priceDisplay: "$8.88",
  pages: 18,
  // 🔧 Paste live Stripe Payment Link when ready
  stripeLink: "https://buy.stripe.com/PLACEHOLDER_COURSE_2",
  pdfDownload: "/downloads/I-GET-TO-Deeper-Return-Course.pdf",
  pdfFileName: "The-Deeper-Return-I-GET-TO-Course-2.pdf",
  landingUrl: "/i-get-to-deeper-return",
  successUrl: "/i-get-to-deeper-success",
  previewImages: [
    "/deeper-preview/page-1.jpg",
    "/deeper-preview/page-2.jpg",
    "/deeper-preview/page-3.jpg",
  ],
  coverImage: "/deeper-preview/page-1.jpg",
  phases: [
    { code: "W", title: "WHERE YOU ARE NOW", note: "Welcome back, Lovely. Notice what shifted." },
    { code: "1", title: "MOVEMENT 1 — BENEATH THE BELIEF", note: "Find the deeper story under the story." },
    { code: "2", title: "MOVEMENT 2 — YOUR DIVINE TEAM, DEEPENED", note: "Discernment. Signs. Higher attunement." },
    { code: "3", title: "MOVEMENT 3 — THE BODY YOU LIVE IN", note: "Somatic literacy. Listen below words." },
    { code: "4", title: "MOVEMENT 4 — RELATIONSHIPS, LEVELED UP", note: "Boundaries that hold. Energy you curate." },
    { code: "5", title: "MOVEMENT 5 — IDENTITY 2.0 & LEGACY", note: "The line, healed backward and forward." },
    { code: "6", title: "MOVEMENT 6 — THE LONG GAME", note: "Relapse-proofing. Becoming the elder you needed." },
  ],
  buyerGroup: "i-get-to-deeper-buyer",
  waitlistGroup: "i-get-to-deeper-waitlist",
};

// ─────────────────────────────────────────────────────────────────────────
// BUNDLE — Both courses, master alignment pricing
// ─────────────────────────────────────────────────────────────────────────
export const BUNDLE = {
  id: "bundle",
  slug: "i-get-to-bundle",
  name: "The Start + Deepen Bundle — Both I GET TO Self-Guided Courses",
  shortName: "Start + Deepen Bundle",
  ladderLabel: "Both",
  tagline:
    "The full 38-page self-guided journey — Start Living I GET TO + The Deeper Return. Master alignment pricing.",
  numerology: "$11.11 — the master alignment. Divine timing. The portal.",
  price: 11.11,
  priceDisplay: "$11.11",
  retailDisplay: "$17.76",
  savingsDisplay: "Save $6.65",
  pages: 38,
  // 🔧 Paste live Stripe Payment Link when ready
  stripeLink: "https://buy.stripe.com/PLACEHOLDER_BUNDLE",
  landingUrl: "/i-get-to-bundle",
  successUrl: "/i-get-to-bundle-success",
  coverImage: "/course-preview/page-1.jpg",
  secondaryCover: "/deeper-preview/page-1.jpg",
  buyerGroup: "i-get-to-bundle-buyer",
  waitlistGroup: "i-get-to-bundle-waitlist",
};

// ─────────────────────────────────────────────────────────────────────────
// Universal helpers
// ─────────────────────────────────────────────────────────────────────────
export const isProductLive = (product) =>
  !product.stripeLink.includes("PLACEHOLDER");

export const SHARED = {
  guarantee: "Love it or your money back. No hard feelings.",
  // Book reference (already live elsewhere)
  bookPrice: 19.99,
  bookPriceDisplay: "$19.99",
  bookUrl: "/book",
};
